export interface AudioCheckInput {
  intendedMic: boolean
  micPublished: boolean
  micMuted: boolean
  micSilent: boolean
  playbackBlocked: boolean
  remoteMicPublished: boolean
  remoteMicMuted: boolean
  inboundAudioBytesDelta?: number
  inboundAudioEnergyDelta?: number
}

export function audioVerdict(input: AudioCheckInput): {
  out: 'ok' | 'muted' | 'silent' | 'none'
  in: 'ok' | 'silent' | 'none' | 'blocked' | 'n/a'
  fault: boolean
} {
  const out = !input.micPublished
    ? 'none'
    : input.micMuted
      ? 'muted'
      : input.micSilent
        ? 'silent'
        : 'ok'
  const remoteUnmuted = input.remoteMicPublished && !input.remoteMicMuted
  const incoming = input.playbackBlocked
    ? 'blocked'
    : !remoteUnmuted
      ? 'n/a'
      : input.inboundAudioBytesDelta === undefined
        ? 'none'
        : input.inboundAudioBytesDelta > 0 || (input.inboundAudioEnergyDelta ?? 0) > 0
          ? 'ok'
          : 'silent'
  // ponytail: totalAudioEnergy≈0 over 60s is also a quiet child; evidence only.
  return {
    out,
    in: incoming,
    fault: (input.intendedMic && (out === 'silent' || out === 'none')) || incoming === 'none',
  }
}
